// extracted by mini-css-extract-plugin
export default {"page_container":"SignupForm_page_container__e+W0Q","container":"SignupForm_container__v144X","inputContainer":"SignupForm_inputContainer__h0E+a","button":"SignupForm_button__y4o47"};